import { toastService } from '@thefarmersfront/kitchen';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { TOAST_MESSAGE } from '~/constants';

/**
 * [입고요청등록] 엑셀 양식 다운로드 API
 */
const fetchRequestGoodsDownloadTemplate = async (ownerCode: string) => {
  const endpoint = '/api-inbound/v1/3pl/receiving';
  const response = await axiosInstance.get(`${endpoint}/${ownerCode}/request/goods/download-template`, {
    responseType: 'blob',
  });
  downloadBlobDataFile(response);
};

/**
 * [입고요청등록] 엑셀 양식 다운로드 Mutation Hook
 */
export const useGetRequestGoodsDownloadTemplateMutation = () => {
  return useDownloadMutation(fetchRequestGoodsDownloadTemplate, {
    onSuccess: () => {
      toastService.addToast({ message: TOAST_MESSAGE.DOWNLOAD_SUCCESS });
    },
    // 에러는 전역 핸들러에서 처리
  });
};
